import React from "react";
import Media from "react-media";
import { Button } from "@material-ui/core";
import { Route } from "react-router-dom";
import { Subscription } from "rxjs";
import { HeaderDesktop } from "../../components/header/desktop/HeaderDesktop";
import { HeaderMobile } from "../../components/header/mobile/HeaderMobile";
import { ApplicationDetailState } from '../../states/ApplicationDetailState';
import { MposWebPortalApi } from "../../services/api/MposWebPortalApi";
import ConfirmDialog from "../../components/dialog/ConfirmDialog";
import { MposLoader } from "../../components/loader/MposLoader";
import { CustomTable } from "../../components/custom-table/CustomTable";
// import { GoogleTagManagerService } from "../../services/analitycs/GoogleTagManagerService";/ApplicationsDto";
import "./ApplicationDetail.scss";

export class ApplicationDetail extends React.Component<any, ApplicationDetailState> {
  private appDetailsSubscription: Subscription | null = null;

  constructor(props: any) {
    super(props);
    this.state = {
      app: this.props.history.location.state.app,
      appDetails: null,
      merchants: [],
      merchantToRemove: null,
      showRemoveAppResultDialog: false,
      showRemoveDelegateResultDialog: false,
      showLoader: false,
      removeAppResult: false,
      removeDelegateResult: false,
      addDelegate: true,
    };
  }

  componentDidMount() {
    const app = this.props.history.location.state.app;

    if (!app) {
      return;
    }

    this.setState({
      showLoader: true,
    })

    this.appDetailsSubscription = MposWebPortalApi.getInstance()
      .getAppDetails(app.appId)
      .subscribe(
        (appDetails: any) => {
          const merchants = appDetails?.merchants !== null ? appDetails?.merchants.map((m: any) => ({
            merchant: m.merchant,
            merchantId: m.merchantId,
            pIva: m.pIva,
          })) : []
          this.setState({
            appDetails: appDetails,
            showLoader: false,
            merchants: merchants,
          })
        },
        () => {
          this.setState({ showLoader: false });
        }
      );
  }

  componentWillUnmount() {
    if (this.appDetailsSubscription != null) {
      this.appDetailsSubscription.unsubscribe();
    }
  }

  renderDesktopHeader(): JSX.Element {
    return (
      <HeaderDesktop
        showBack
        showBackText
        backTextLightColor
        showLogout={false}
        showTitle
        hideBorder
        background="#171A67"
        buttonContentColor="#FFF"
        isSpecial
      >
        <div className="application-details-header-content">
          <p className="application-details-header-name">{this.state.app?.appName}</p>
          <Button
            id={"user-details-header-button-revoke"}
            onClick={() => {
              this.toggleDeleteAppModal();
            }}
            disableRipple
          >
            ELIMINA APP
          </Button>
        </div>
      </HeaderDesktop>
    );
  }

  renderMobileHeader(): JSX.Element {
    return (
      <HeaderMobile
        showBack={true}
        showLogout={false}
        showTitle={false}
        hideBorder={true}
        background="#171A67"
        buttonContentColor="#FFF"
        isSpecial
      >
        <div className="application-details-header-content">
          <p className="application-details-header-name">{this.state.app?.appName}</p>
          <Button
            id={"user-details-header-button-revoke"}
            onClick={() => {
              this.toggleDeleteAppModal();
            }}
            disableRipple
          >
            ELIMINA APP
          </Button>
        </div>
      </HeaderMobile>
    );
  }

  toggleDeleteAppModal = () => {
    this.setState({
      showRemoveAppResultDialog: !this.state.showRemoveAppResultDialog,
    });
  };

  toggleRemoveDelegateModal = () => {
    this.setState({
      showRemoveDelegateResultDialog: !this.state.showRemoveDelegateResultDialog,
    });
  };

  invokeDeleteApp(appId: string | null) {
    this.setState({ showLoader: true });
    MposWebPortalApi.getInstance()
      .deleteApp(appId)
      .subscribe(
        () => {
          this.setState({
            showLoader: false,
            showRemoveAppResultDialog: true,
            removeAppResult: true
          });
          this.showDeleteAppResult();
        },
        () => {
          this.setState({
            showLoader: false,
            showRemoveAppResultDialog: true,
            removeAppResult: false
          });
          this.showDeleteAppResult();
        }
      );
  }

  showDeleteAppResult() {
    this.props.history.push("/result", {
      isSuccess: this.state.removeAppResult,
      title: `Hai eliminato l'applicazione ${this.state.app?.appName}.`,
      message: "",
      button: "Torna alla lista applicazioni",
      data: { from: "Applications", operation: "deleteApp" },
    });
  }

  invokeRemoveDelegation(merchantId: string | null) {
    this.setState({ showLoader: true });

    const payload = {
      appName: this.state.app?.appName,
      merchantId: merchantId
    }

    MposWebPortalApi.getInstance()
      .removeMerchantFromApp(payload)
      .subscribe(
        () => {
          this.setState({
            showLoader: false,
            showRemoveDelegateResultDialog: true,
            removeDelegateResult: true
          });
          this.showDeleteDelegateResult();
        },
        () => {
          this.setState({
            showLoader: false,
            showRemoveDelegateResultDialog: true,
            removeDelegateResult: false
          });
          this.showDeleteDelegateResult();
        }
      );
  }

  showDeleteDelegateResult() {
    this.props.history.push("/result", {
      isSuccess: this.state.removeDelegateResult,
      title: `Hai eliminato il merchant ${this.state.merchantToRemove?.merchant}.`,
      message: "",
      button: "Torna alla lista applicazioni",
      data: { from: "Applications", operation: "deleteApp" },
    });
  }

  startAddDelegationFlow(history: any) {
    // Stessa pagina di assegnazione deleghe in fase di creazione
    history.push('/assignApp', {
      addDelegate: this.state.addDelegate, // this.props.location.state.addDelegate,
      headerTitle: 'AGGIUNGI PUNTO VENDITA', // `${this.props.location.state.headerTitle}.`,
      appName: this.state.app?.appName,
    });
  }

  render() {
    return (
      <>
        {
          // @ts-ignore
          <MposLoader show={this.state.showLoader} />
        }
        <div id="main-container-application-details">
          <Media query="(max-width: 1064px)" render={() => this.renderMobileHeader()} />
          <Media query="(min-width: 1065px)" render={() => this.renderDesktopHeader()} />
          <div className="application-content">
            <div className="application-section">
              <div className="application-title-container">
                <p className="application-title">CHIAVI API</p>
              </div>
              <p className="application-paragraph">Grazie a queste chiavi potrai autenticare le richieste API.</p>
              <div className="application-detail-keys-container">
                <div className="application-field">
                  <p className="label">ID Client</p>
                  <p className="value">{this.state.appDetails?.client_id ? this.state.appDetails.client_id : "-"}</p>
                </div>
                <div className="application-field">
                  <p className="label">Secret</p>
                  <p className="value">{this.state.appDetails?.client_secret ? this.state.appDetails.client_secret : "-"}</p>
                </div>
              </div>
            </div>
            <div className="application-section">
              <div className="application-title-container">
                <p className="application-title">PUNTI VENDITA ASSOCIATI ALL’APP</p>
                <Route render={({ history }) => {
                  return (
                    <Button
                      className="application-detail-add-delegation"
                      type={"button"}
                      onClick={() => this.startAddDelegationFlow(history)}
                    >
                      AGGIUNGI PUNTO VENDITA
                    </Button>
                  )
                }} />
              </div>
              <div className="application-field-container">
                <p className="application-paragraph">Qui puoi visualizzare i punti vendita associati a quest’app.</p>
                <CustomTable
                  data={this.state.merchants}
                  rowsPerPage={10}
                  headerLabels={
                    ['ID AMMINISTRATORE', 'ID PUNTO VENDITA', 'P.IVA']
                  }
                  isCallToAction
                  ctaLabel="rimuovi"
                  ctaOnClick={(merchant: any) => {
                    this.toggleRemoveDelegateModal();
                    this.setState({
                      merchantToRemove: merchant, //HERE: da rivedere con vera api
                    })
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <ConfirmDialog
          id="app-delete-confirm-dialog"
          show={this.state.showRemoveAppResultDialog}
          onClose={() => this.toggleDeleteAppModal()}
          title="Eliminazione App"
          content={`Sei sicuro di voler eliminare l'applicazione ${this.state.app?.appName}?`}
          buttonNoText="ANNULLA"
          buttonYesText="CONFERMA"
          onConfirm={() => this.invokeDeleteApp(this.state.app!.appId)}
        />
        <ConfirmDialog
          id="delegate-delete-confirm-dialog"
          show={this.state.showRemoveDelegateResultDialog}
          onClose={() => this.toggleRemoveDelegateModal()}
          title="Rimozione Merchant"
          content={`Sei sicuro di voler rimuovere il merchant ${this.state.merchantToRemove?.merchant}?`}
          buttonNoText="ANNULLA"
          buttonYesText="CONFERMA"
          onConfirm={() => this.invokeRemoveDelegation(this.state.merchantToRemove!.merchantId)}
        />
      </>
    );
  }
}